// @flow
/**
 * Created by Mike Chung on 2/27/18.
 */
import React from "react";
import * as _ from "lodash";

type TableHeadProps = {
    className?: string
}

export default function TableHead(props: TableHeadProps) {
    const {className, ...rest} = props;
    let clazz = `divTableHead ${_.defaultTo(className, "")}`;
    return (
        <div className={clazz} {...rest} />
    );
}


// WEBPACK FOOTER //
// ./src/components/util/tables/TableHead.js